export default __webpack_public_path__ + "static/wave_undorm-acbc1cde2988deb031d4471c8a9aa2c2.png";